import { AfterViewChecked,  Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { IExtensionService, IReport } from '../../models/interfaces.model';
import { AbcCore, FileHelper } from '@barthauer/abc/core';
import { AppService } from '../../services/app.service';
import { ActivatedRoute } from '@angular/router';
import { UbtLoaderComponent } from '../ubt-loader/ubt-loader.component';
import { LandingPageService } from './landing-page.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  standalone: true,
  imports: [
        UbtLoaderComponent,
  ],
  
})
export class LandingPageComponent implements OnInit, AfterViewChecked  {
    public reportPendingMessage : string;
    public loadingMessage : string;
    public reportParameters: IReport | null = null;
    showLoader = false; 
      
    constructor(
        public dataService: DataService,
        public appService: AppService,
        private landingPageService: LandingPageService,
        private abcCore: AbcCore,
        private route: ActivatedRoute
    ){}
    ngAfterViewChecked(): void {
        this.reportPendingMessage = this.dataService.res('Waiting-PowerPoint');
        this.loadingMessage = this.dataService.res('Loading');
        
    }
    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
          if (params['data']) {
            try {
             
              this.reportParameters = JSON.parse(atob(params['data']));
              this.generateReport(this.reportParameters);
            } catch (error) {
              console.error('Error decoding report parameters:', error);
            }
          }
        });
      }

         public async generateReport(reportData :IReport): Promise<void> {
            
            this.appService.showLoader(true);
            try {
              const reportParameters: IReport = {
                ProjectId: reportData.ProjectId,
                StartingFrom: reportData.StartingFrom,
              };
              await this.landingPageService
                .generateReport(reportParameters)
                .toPromise()
                .then((data) => {
                  const reportBase64 = data as unknown as IExtensionService<IReport>;
                  const fileName: string = localStorage.getItem("projectName");
                  FileHelper.downloadPptxFromBase64(
                    reportBase64.Data.FileContent,
                    fileName
                  );
                });
            } catch (error) {
              this.abcCore.error.publish(error);
            } finally {
                
              this.appService.showLoader(false);
            }
          }
   
        

}